// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
import type * as SchemaTypes from '../../../../../../graphql/api/index';

import { gql } from 'graphql-tag';
import { QuestionnaireQuestionChoiceOptionContentFragmentDoc } from './QuestionnaireQuestionChoiceOptionContent.fragment.generated';
import { QuestionnaireQuestionChoiceOptionBehaviourFragmentDoc } from './questionnaireQuestionChoiceOptionBehaviour.fragment.generated';
export const QuestionnaireQuestionChoiceOptionFragmentDoc = gql`
    fragment questionnaireQuestionChoiceOption on QuestionnaireQuestionChoiceOption {
  __typename
  id
  content {
    __typename
    ...questionnaireQuestionChoiceOptionContent
  }
  behaviour {
    ...questionnaireQuestionChoiceOptionBehaviour
  }
}
    ${QuestionnaireQuestionChoiceOptionContentFragmentDoc}
${QuestionnaireQuestionChoiceOptionBehaviourFragmentDoc}`;